export const TOGGLE_DIALOGS = "TOGGLE_DIALOGS";

export const CLEAR_MICROHUB_STATE = "CLEAR_MICROHUB_STATE";

export const GET_ALL_HUBS = "GET_ALL_HUBS";
export const GET_ALL_HUBS_FAIL = "GET_ALL_HUBS_FAIL";
export const GET_ALL_HUBS_SUCCESS = "GET_ALL_HUBS_SUCCESS";

export const CREATE_HUB = "CREATE_HUB";
export const CREATE_HUB_FAIL = "CREATE_HUB_FAIL";
export const CREATE_HUB_SUCCESS = "CREATE_HUB_SUCCESS";

export const EDIT_HUB = "EDIT_HUB";
export const EDIT_HUB_FAIL = "EDIT_HUB_FAIL";
export const EDIT_HUB_SUCCESS = "EDIT_HUB_SUCCESS";

export const DELETE_HUB = "DELETE_HUB";
export const DELETE_HUB_FAIL = "DELETE_HUB_FAIL";
export const DELETE_HUB_SUCCESS = "DELETE_HUB_SUCCESS";

export const GET_HUB_BY_ID = "GET_HUB_BY_ID";
export const GET_HUB_BY_ID_FAIL = "GET_HUB_BY_ID_FAIL";
export const GET_HUB_BY_ID_SUCCESS = "GET_HUB_BY_ID_SUCCESS";

export const ASSIGN_POLYGON_TO_HUB = "ASSIGN_POLYGON_TO_HUB";
export const ASSIGN_POLYGON_TO_HUB_FAIL = "ASSIGN_POLYGON_TO_HUB_FAIL";
export const ASSIGN_POLYGON_TO_HUB_SUCCESS = "ASSIGN_POLYGON_TO_HUB_SUCCESS";

export const REMOVE_HUB_FROM_POLYGON = "REMOVE_HUB_FROM_POLYGON";
export const REMOVE_HUB_FROM_POLYGON_FAIL = "REMOVE_HUB_FROM_POLYGON_FAIL";
export const REMOVE_HUB_FROM_POLYGON_SUCCESS = "REMOVE_HUB_FROM_POLYGON_SUCCESS";